import axios from 'services/axios';
import { checkForLocalAuthToken } from './AuthModel';

const CROPWISE_API_BASE_URL = import.meta.env.VITE_APP_CROPWISE_API_URL;

export const getRawPropertyData = async (orgId: string) => {
  try {
    const tokenStore = checkForLocalAuthToken();
    const response: any = await axios.request({
      method: 'GET',
      url: `${CROPWISE_API_BASE_URL}/v2/orgs/${orgId}/properties`,
      headers: { authorization: `Bearer ${tokenStore?.access_token}` },
    });
    return response.data?.content;
  } catch (err: any) {
    console.error('get properties data failed error:', err);
    return [];
  }
};

export const getFieldsFromPropertyId = async (propertyId: string) => {
  try {
    const tokenStore = checkForLocalAuthToken();
    const response: any = await axios.request({
      method: 'GET',
      url: `${CROPWISE_API_BASE_URL}/v2/fields?parent_region_id=${propertyId}`,
      headers: { authorization: `Bearer ${tokenStore.access_token}` },
    });
    return response.data?.content;
  } catch (err: any) {
    console.error('get fields data failed error:', err);
    return [];
  }
};
